<div class="cg-dialog">
  <h2 class="cg-dialog__header">
    Disclaimer<button
      cignaButton="link inline no-underline"
      class="cg-dialog__close_new"
      (click)="dialogRef.close()"
    >
      Close
      <cigna-icon class="cml-close-icon" type="close-thin"></cigna-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <h4 class="cg-margin-bottom-sm">Legal Disclaimer</h4>

    <cigna-collapsible-item
      headerText="Products and Services Provided by Cigna Corporation Subsidiaries"
      ><p>
        "Cigna<sup>&reg;</sup>" is a registered service mark of Cigna
        Intellectual Property, Inc., licensed for use by Cigna Corporation and
        its subsidiaries. Cigna Corporation is a holding company and is not an
        insurance or an operating company. Therefore, products and services are
        provided exclusively by subsidiaries and not by Cigna Corporation.
        "Cigna" may refer to Cigna Corporation itself or one or more of its
        subsidiaries, but when used in connection with the provision of a
        product or service, always refers to a subsidiary.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="Product Descriptions - Not Available in all States"
    >
      <p>
        The product descriptions, if any, provided on Cigna web sites are not
        intended to constitute offers to sell or solicitations in connection
        with any products or services. Some products may not be available in all
        jurisdictions. Anyone interested in a particular product should contact
        the indicated Cigna business to determine whether the product is
        available in their jurisdiction and to request a copy of the applicable
        policy or prospectus for a complete description of the product.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Links to Cigna Web Sites">
      <p>
        Cigna grants a nonexclusive, limited permission to the owners of other
        web sites ("Linking Site Owners") to link to Cigna web sites using text
        links. Such link shall not (a) suggest that Cigna promotes or endorses
        any third party's causes, web sites, products or services, or (b) be
        used or associated with any inflammatory, pornographic, defamatory or
        unlawful site or materials in any way, or in any manner that would
        disparage or adversely affect the name, reputation and goodwill of Cigna
        and its products and services.
      </p>
      <p>
        Cigna retains and reserves all rights to its domain names, trade names,
        trademarks and logos, copyrights and all other intellectual property. We
        reserve the right to withdraw permission for any link.
      </p>
      <p>
        Linking Site Owners shall indemnify, defend and hold harmless Cigna from
        and against all liability, demands, claims, suits, losses, damages,
        infringement of proprietary rights, causes of action, fines, or
        judgments (including costs, attorneys' and witnesses' fees, and expenses
        incident thereto), arising out of their failure to comply with the terms
        and conditions of this "Links to Cigna Web Sites" section.
      </p>
      <p>
        Linking Site Owners who desire to link to Cigna web sites using Cigna's
        "Tree of Life" logo must comply with the requirements set forth in
        <a
          href="http://www.cigna.com/legal-disclaimer?redir=/legal/link_to_our_site.html"
          target="_blank"
          rel="noopener noreferrer"
          >Link to Our Site with a Cigna Logo</a
        >, including the completion of the Linking License Application Form and
        execution of the Linking License Agreement.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Links to Other Sites">
      <p>
        While visiting Cigna web sites, you may leave them and access certain
        non-Cigna Web sites. Cigna neither reviews nor controls the content and
        accuracy of these Web sites, and therefore will not be responsible for
        their content and accuracy. Your access to non-Cigna Web sites is at
        your sole risk.<br />
        Other Web sites on the Internet may contain unedited, sexually explicit,
        violent, racist or other types of material, which may be offensive to
        you. Please access other Web sites at your own discretion.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="General Disclaimer">
      <p>
        All material including any link to other sites and content found at
        linked sites is provided "as is" and without any express or implied
        warranties including warranties of merchantability or fitness for a
        particular purpose. Due to the nature of the Internet, Cigna does not
        warrant that access to Cigna web sites or any of their pages will be
        uninterrupted or error free. Cigna does not warrant or make any
        representations regarding the usefulness of or the expected results of
        the material contained on Cigna web sites. Note that some jurisdictions
        may not allow the exclusion of implied warranties so some of the above
        exclusions may not apply to you. Please check your local laws for any
        such restrictions.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Viruses, Worms, Use of Files">
      <p>
        Cigna cannot and does not guarantee or warrant that files available for
        downloading from this site are free of viruses, worms, Trojan horses or
        other code that has contaminating or destructive properties. Cigna does
        not make any express or implied warranties, representations or
        endorsements whatsoever (including without limitation warranties of
        title, noninfringement or fitness for a particular purpose) with respect
        to the files available for downloading from this site. In no event will
        Cigna be liable to you or to anyone else for any decision made or action
        taken by you or anyone else in reliance on results obtained from use of
        files downloaded from this site. These files may be downloaded and/or
        reprinted for personal use only. Permission to reprint or electronically
        reproduce any document or graphic in whole or in part for any reason
        except for personal use is expressly prohibited, unless prior written
        consent is obtained from the appropriate Cigna copyright holder.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Health Information">
      <p>
        The health information on Cigna web sites is provided by Cigna solely
        for informational purposes as a public service to promote consumer
        health. It does not constitute medical advice and is not intended to be
        a substitute for proper medical care provided by a physician. Cigna
        assumes no responsibility for any circumstances arising out of the use,
        misuse, interpretation or application of any information supplied on
        Cigna web sites. Always consult with your doctor for appropriate
        examinations, treatment, testing, and care recommendations. Do not rely
        on information on this site as a tool for self-diagnosis.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Forward-Looking Statements">
      <p>
        Cigna web sites may from time to time contain forward-looking statements
        that include information about financial prospects, plans and objectives
        of management for future operations, economic conditions, trends and
        known uncertainties. Cigna cautions the reader that actual results could
        differ materially from those that Cigna expects, depending on the
        outcome of certain factors. In some cases, Cigna describes uncertainties
        when offering forward-looking statements. Some factors that could cause
        Cigna's actual results to differ materially from forward-looking
        statements ("Risk Factors") are listed in the most recent Form 10-K or
        Form 10-Q Cigna filed with the Securities and Exchange Commission.
      </p>
      <p>
        Cigna does not undertake any obligation to correct or update any
        forward-looking statements on the Cigna web sites. Cigna also cautions
        the reader that the list of Risk Factors that appears in the most recent
        Form 10-K or Form 10-Q Cigna filed with the SEC may be modified by any
        subsequent SEC filings, such as Form 8-K, proxy statements, and other
        SEC filings. Cigna will not update the Risk Factors listed in any of
        Cigna's
        <a
          href="http://www.sec.gov/cgi-bin/srch-edgar?0000701221"
          target="_blank"
          rel="noopener noreferrer"
          class="link-thirdParty"
          >SEC filings</a
        >
        prior to the next required SEC filing. The list of Risk Factors provided
        in any of Cigna's SEC filing may not be complete, and speaks only as of
        the date filed with the SEC.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Trademarks">
      <p>
        There are references throughout Cigna web sites to various trademarks or
        service marks and these, whether registered or not, are the property of
        their respective owners
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Message Boards and Chat Rooms">
      <p>
        It is a condition of your use of Message Boards or Chat Rooms that you
        do not: (i) post or transmit any unlawful, threatening, abusive,
        libelous, defamatory, racial, obscene, vulgar, pornographic, profane or
        indecent information of any kind, including without limitation any
        transmissions constituting or encouraging conduct that would constitute
        a criminal offense, give rise to civil liability or otherwise violate
        any local, state, national or international law; (ii) post or transmit
        comments containing harassing or offensive language, using sexual
        references, sexual nicknames, racial slurs or rude or deliberately
        offensive comments or engage in disruptive activity online, including
        excessive use of scripts, sound waves, scrolling (repeating the same
        message over and over), or use viruses, worms or Trojan horses; (iii)
        post or transmit any information, software or other material which
        violates or infringes the rights of others, including material which is
        an invasion of privacy or publicity rights or which is protected by
        copyright, trademark or other proprietary right, or derivative works
        without first obtaining permission from the owner; (iv) post or transmit
        any information, software or other material which contains a virus,
        worm, Trojan horse or other code that has contaminating or destructive
        properties; (v) post any information, software, or other material for
        commercial purposes; (vi) solicit other users to join or contribute
        money to any online service or other organization, advocate or attempt
        to get users to join in legal or illegal schemes; (vii) impersonate any
        person or entity or falsely represent your professional or other
        affiliation with any person or entity; or (viii) use Cigna web sites to
        collect personally identifiable information in violation of our Privacy
        Policy. You agree Cigna, at its sole and absolute discretion, shall
        determine whether any information transmitted or received violates this
        provision.
      </p>
      <p>
        You agree to indemnify and hold Cigna and its employees, officers,
        directors and agents harmless from any claim or demand, including
        reasonable attorneys' fees, made by a third party arising from any
        material you contribute to Message Boards or Chat Rooms you access via
        Cigna web sites.
      </p>
      <p>
        You understand that Cigna has no obligation to monitor Message Boards or
        Chat Rooms. Cigna reserves the right at all times to disclose any
        information regarding the Message Boards or Chat Rooms, or to remove any
        information or materials, in whole or in part, that in Cigna's sole and
        absolute discretion are objectionable. You acknowledge that Cigna
        reserves the right to monitor any and all information transmitted or
        received through Cigna web sites which may be examined, recorded,
        copied, and used in accordance with our
        <a href="https://my.cigna.com/public/privacy_policy.html" target="_self"
          >Cigna Privacy Information</a
        >. Use of Cigna web sites constitutes consent to such activity by Cigna.
      </p>
      <p>
        When using Cigna web sites, please be certain that anything you disclose
        does not compromise your personal safety. Do not provide your name,
        phone number, social security number or any other personally identifying
        information to people you do not know. Do not continue any conversation
        online that makes you feel uncomfortable.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Limitation of Liability">
      <p>
        You agree by accessing Cigna web sites that under no circumstances or
        any theories of liability under international or civil, common or
        statutory law including but not limited to strict liability, negligence
        or other tort theories or contract, patent or copyright laws, will Cigna
        be liable for damages of any kind occurring from the use of Cigna web
        sites or any information, goods or services obtained on Cigna web sites
        including direct, indirect, consequential, incidental, or punitive
        damages (even if Cigna has been advised of the possibility of such
        damages), to the fullest extent permitted by law. Some jurisdictions do
        not allow the exclusion or limitation of certain damages so some of
        these limitations may not apply to you.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Calculations and Investment Decisions">
      <p>
        Financial calculators/calculations are provided for illustrative
        purposes only. You are responsible for verifying the accuracy and
        suitability of all assumptions and calculations. Please seek the advice
        of licensed and/or competent individuals before making any investment or
        Financial planning decisions. Do not rely solely on financial
        calculators/calculations or financial or retirement information found on
        Cigna web sites.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item
      headerText="Minors and the Children's Online Privacy Protection Act"
    >
      <p>
        Except as expressly stated upon initial access to a specific Cigna web
        site or section of such site, Cigna web sites do not direct content to
        Minors and do not intend to collect personal information from Minors and
        therefore are not subject to the Children's Online Privacy Protection
        Act.
      </p>
      <p>
        If you allow your minor child, or a child for whom you are legal
        guardian (a "Minor"), to access and use Cigna web sites, you agree that
        you will be solely responsible for: (i) the online conduct of such
        Minor; (ii) monitoring such Minor's access to and use of Cigna web
        sites; and (iii) the consequences of any use.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="The Digital Millennium Copyright Act">
      <p>
        Cigna reserves the right, but not the obligation, to terminate your
        access to Cigna web sites if it determines in its sole and absolute
        discretion that you are involved in infringing activity, including
        alleged acts of first-time or repeat infringement, regardless of whether
        the material or activity is ultimately determined to be infringing.
        Cigna and its service providers accommodate and do not interfere with
        standard technical measures used by copyright owners to protect
        materials. Cigna has implemented procedures for receiving written
        notification of claimed infringements and for processing such claims in
        accordance with the Act. Our designated agent to receive notification of
        claimed infringement is: <br />
        Timothy Tammany, Esq.<br />
        Two Liberty Place <br />
        1601 Chestnut Street <br />
        Philadelphia, PA 19192 <br />
        215-761-1000
      </p>
      <p>
        Any notice regarding any infringement of copyright or of other
        proprietary rights must include the following information:
      </p>
      <ol>
        <li>
          A signature of a person authorized to act on behalf of (i) the owner
          of an exclusive right that is allegedly infringed or (ii) the person
          defamed.
        </li>
        <li>
          Identification of the copyrighted work claimed to have been infringed,
          or, if multiple copyrighted works at a single online site are covered
          by a single notification, a representative list of such works at that
          site.
        </li>
        <li>
          Identification of the material that is claimed to be infringing, or to
          be the subject of infringing activity, including information
          reasonably sufficient to permit us to locate the material.
        </li>
        <li>
          Information reasonably sufficient to permit us to contact you, such as
          your address, telephone number, and/or electronic mail address.
        </li>
        <li>
          A statement that you have a good faith belief that use of the material
          in the manner complained of is not authorized by the copyright or
          other proprietary right owner, its agent, or the law.
        </li>
      </ol>
      <p>
        If you choose to access Cigna web sites from outside the United States
        you do so on your own initiative and are responsible for compliance with
        U.S. and local laws, if and to the extent that local laws are
        applicable. Software is subject to United States export controls. No
        software may be downloaded or otherwise exported or re-exported (i) into
        (or to a national resident of) Cuba, Iraq, Libya, North Korea, Iran,
        Syria, or any other country to which the U.S. has embargoed goods, or
        (ii) to anyone on the U.S. Treasury Department list of Specially
        Designated Nationals or the U.S. Commerce Department's Table of Deny
        Orders. You represent and warrant that you are not located in, under the
        control of, or a national resident of any such country or on any such
        list. You agree to comply with U.S. export control laws and that you
        will not transfer any software or other content from Cigna web sites to
        a foreign national or foreign country in violation of those laws.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Disclosure of Financial Arrangements">
      <p><strong>Compensation to Third Parties</strong></p>
      <p>
        Compensation is paid to third party brokers and insurance sales people
        for placing a Client's ("Client" refers to employers or other groups
        sponsoring a health benefit plan) insurance coverage and/or plan
        administration contract with Cigna. This compensation is typically in
        the form of a percentage of premiums collected in the case of insurance
        policies, or a fixed, per-employee per-month rate (in the case of
        self-funded plans).
      </p>
      <p>
        Additional compensation may be paid to brokers and insurance sales
        people based on persistency or other non-case-specific factors,
        sometimes referred to as "contingent commissions." This additional
        compensation is not part of the regular commissions.
      </p>
      <p>
        Reports are sent to its employer policyholders and contract-holders
        regarding the commission and contingent commissions paid to brokers or
        insurance sales people for their use in preparing their Annual Return
        and report (Form 5500) where required under federal law (ERISA). Upon
        request, we will also disclose how the client may receive more
        information directly from the broker or sales person regarding
        compensation arrangements.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Primary Source of Revenue">
      <p>
        The primary compensation received with respect to insurance policies is
        the policyholder paid insurance premium. The primary source of revenue
        in connection with administrative services contracts is the service fees
        paid by the self-insured plan sponsor and/or the plan.
      </p>
    </cigna-collapsible-item>
    <cigna-collapsible-item headerText="Other Revenue Sources">
      <p>
        We negotiate for additional revenue from some third party vendors. We
        negotiate the additional revenue as part of the overall structure of
        each vendor agreement. The nature of negotiated contracts with vendors
        is that they are generally based on the aggregation of all business
        related to the contract and are not client-specific.
      </p>
    </cigna-collapsible-item>
  </mat-dialog-content>
</div>
